import React from 'react';
import { useGradientPickerController } from './useGradientPickerController';
import { MockedProductCard } from './mockedProductCard';

interface GradientPickerProps {
  onChange?: (gradient: {
    colors: string[];
    positions: number[];
    type: 'linear' | 'radial';
    angle?: number;
  }) => void;
  defaultType?: 'linear' | 'radial';
  defaultColors?: string[];
  defaultPositions?: number[];
  defaultAngle?: number;
  className?: string;
}

export const GradientPicker: React.FC<GradientPickerProps> = ({
  onChange,
  defaultType = 'linear',
  defaultColors = ['#22C1C3', '#FDBB2D'],
  defaultPositions = [0, 100],
  defaultAngle = 0,
  className,
}) => {
  const {
    gradientType,
    colors,
    positions,
    angle,
    rgbaValues,
    currentColorIndex,
    colorPickerRef,
    spectrumRef,
    gradientString,
    colorPresets,
    currentHue,
    pickerPosition,
    setAngle,
    setColors,
    updateRgba,
    setPositions,
    addColorStop,
    updatePosition,
    setGradientType,
    removeColorStop,
    updateColorStop,
    setCurrentColorIndex,
    handleSpectrumMouseDown,
    handleAngleCircleMouseDown,
    handleColorPickerMouseDown
  } = useGradientPickerController({
    onChange,
    defaultType,
    defaultColors,
    defaultPositions,
    defaultAngle
  })
  return (
    <div className="bg-white p-2 rounded-lg shadow-lg max-w-4xl mx-auto">
      <div className="flex flex-col md:flex-row gap-6 items-center -mt-10 w-full p-4">
        {/* Color Presets */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2 w-full md:w-1/3">
          {colorPresets.map((preset, index) => (
            <button
              key={index}
              className="h-8 rounded-md cursor-pointer hover:scale-105 transition-transform"
              style={{
                background: Array.isArray(preset)
                  ? `linear-gradient(to right, ${preset.join(', ')})`
                  : preset
              }}
              onClick={(e) => {
                e.preventDefault();
                if (Array.isArray(preset)) {
                  const newColors = [...preset];
                  const newPositions = preset.map((_, i) =>
                    i === 0 ? 0 : i === preset.length - 1 ? 100 : Math.round(100 * i / (preset.length - 1))
                  );
                  setColors(newColors);
                  setPositions(newPositions);
                  setCurrentColorIndex(0);
                } else if (currentColorIndex !== null) {
                  updateColorStop(currentColorIndex, preset);
                }
              }}
              aria-label={`Color preset ${index + 1}`}
            />
          ))}
        </div>

        {/* Mocked Product Card */}
        <div className="w-full md:w-1/3 flex justify-center">
          <MockedProductCard
            colors={colors}
            positions={positions}
            currentColorIndex={currentColorIndex}
            gradient={gradientString}
            onIndexChange={setCurrentColorIndex}
          />
        </div>

        {/* Gradient Controls */}
        <div className="w-full md:w-1/3 flex flex-col gap-4">
          <div className="flex flex-wrap justify-between items-center gap-4">
            <div className="join">
              <button
                className={`btn join-item p-2 ${gradientType === 'linear' ? 'btn-neutral' : 'btn-outline'}`}
                onClick={(e) => {
                  e.preventDefault();
                  setGradientType('linear');
                }}
              >
                Linear
              </button>
              <button
                className={`btn join-item p-2 ${gradientType === 'radial' ? 'btn-neutral' : 'btn-outline'}`}
                onClick={(e) => {
                  e.preventDefault();
                  setGradientType('radial');
                }}
              >
                Radial
              </button>
            </div>

            {gradientType === 'linear' && (
              <div className="flex items-center gap-2">
                <div
                  id="angle-circle"
                  className="w-10 h-10 rounded-full border border-gray-300 relative cursor-pointer"
                  onMouseDown={handleAngleCircleMouseDown}
                >
                  <div
                    className="absolute w-2 h-2 bg-blue-500 rounded-full"
                    style={{
                      left: '30%',
                      top: '30%',
                      transform: `translate(-50%, -50%) rotate(${angle}deg) translateX(4px)`
                    }}
                  />
                </div>
                <input
                  type="number"
                  min="0"
                  max="360"
                  value={angle}
                  onChange={(e) => setAngle(parseInt(e.target.value, 10) % 360)}
                  className="input input-bordered input-sm w-16 text-center"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Gradient Preview Bar */}
      {/* <div className="relative mb-4 w-full h-40 rounded-md overflow-hidden"> */}
      {/* Gradient en fond */}
      {/* <div
          className="absolute inset-0 z-0"
          style={{
            background: gradientString,
          }}
        /> */}


      {/* changer l'image plus tard */}
      {/* <img
          src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.pngmart.com%2Ffiles%2F16%2FPlastic-Water-Bottle-PNG-HD.png&f=1&nofb=1&ipt=73c431f46828ba1c9d7e2bf64f50fabe3e519b17ce7a43e639a18068f76b5b3f"
          alt="Bouteille"
          className="absolute z-10 w-[125px] h-[165px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none"
        /> */}

      {/* Points de couleur */}
      {/* {colors.map((color, index) => (
          <div
            key={index}
            className={`w-4 h-4 rounded-full border-2 border-white absolute -translate-x-1/2 top-1/2 -translate-y-1/2 cursor-grab hover:scale-110 transition-transform ${currentColorIndex === index
              ? 'ring-2 ring-blue-500 ring-offset-2 scale-125 z-20'
              : ''
              }`}
            style={{
              left: `${positions[index]}%`,
              backgroundColor: color,
              zIndex: 20,
            }}
            onClick={(e) => {
              e.preventDefault();
              setCurrentColorIndex(index);
            }}
          />
        ))} */}

      {/* Position inputs */}
      {/* <div className="absolute bottom-1 w-full px-2 flex justify-between z-30">
        <input
          type="number"
          value="0"
          className="input input-bordered input-sm w-16 text-center"
          disabled
        />
        <input
          type="number"
          value="100"
          className="input input-bordered input-sm w-16 text-center"
          disabled
        />
      </div> */}
      {/* </div> */}

      {/* Color Controls */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div className="bg-gray-100 p-3 rounded-lg">
          <h3 className="text-xs font-bold text-gray-500 mb-2">PICKER</h3>
          {/* Main color picker */}
          {/* Color spectrum slider */}
          <div className="mb-2 h-6 relative rounded-md overflow-hidden">
            <div
              ref={spectrumRef}
              className="w-full h-full cursor-pointer"
              style={{
                background: 'linear-gradient(to right, #f00, #ff0, #0f0, #0ff, #00f, #f0f, #f00)'
              }}
              onMouseDown={handleSpectrumMouseDown}
            />

            <div
              className="absolute top-0 w-2 h-full cursor-grab transform -translate-x-1/2"
              style={{
                left: `${(currentHue / 360) * 100}%`,
                backgroundColor: 'white',
                boxShadow: '0 0 2px rgba(0, 0, 0, 0.5)'
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
                handleSpectrumMouseDown(e);
              }}
            />
          </div>
          <div
            ref={colorPickerRef}
            className="aspect-square relative rounded-md overflow-hidden cursor-crosshair"
            onMouseDown={handleColorPickerMouseDown}
            style={{
              background: `linear-gradient(to right, #fff, hsl(${currentHue}, 100%, 50%)),
                           linear-gradient(to bottom, rgba(0,0,0,0), #000)`,
              backgroundBlendMode: 'multiply'
            }}
          >
            {currentColorIndex !== null && (
              <div
                className="absolute w-4 h-4 border-2 border-white rounded-full -translate-x-1/2 -translate-y-1/2 shadow-md pointer-events-none"
                style={{
                  left: `${pickerPosition.x}%`,
                  top: `${pickerPosition.y}%`
                }}
              />
            )}
          </div>
        </div>

        <div className="bg-gray-100 p-3 rounded-lg">
          <h3 className="text-xs font-bold text-gray-500 mb-2">HEX</h3>
          <input
            type="text"
            value={currentColorIndex !== null ? colors[currentColorIndex] : ''}
            onChange={(e) => updateColorStop(currentColorIndex, e.target.value)}
            className="input input-bordered w-full mb-2"
          />

          <div className="grid grid-cols-4 gap-1 mb-2">
            <span>R</span>
            <span>G</span>
            <span>B</span>
            <span>A</span>

            <input
              type="number"
              min="0"
              max="255"
              value={rgbaValues.r}
              onChange={(e) => updateRgba('r', parseInt(e.target.value, 10))}
              className="input input-bordered input-xs text-center"
            />
            <input
              type="number"
              min="0"
              max="255"
              value={rgbaValues.g}
              onChange={(e) => updateRgba('g', parseInt(e.target.value, 10))}
              className="input input-bordered input-xs text-center"
            />
            <input
              type="number"
              min="0"
              max="255"
              value={rgbaValues.b}
              onChange={(e) => updateRgba('b', parseInt(e.target.value, 10))}
              className="input input-bordered input-xs text-center"
            />
            <input
              type="number"
              min="0"
              max="100"
              step="1"
              value={rgbaValues.a}
              onChange={(e) => updateRgba('a', parseFloat(e.target.value))}
              className="input input-bordered input-xs text-center"
            />
          </div>

          <div className="mt-4">
            <input
              type="range"
              min="0"
              max="100"
              value={currentColorIndex !== null ? positions[currentColorIndex] : 0}
              onChange={(e) => updatePosition(currentColorIndex, parseInt(e.target.value, 10))}
              className="range range-primary range-xs w-full"
              disabled={currentColorIndex === null}
            />
          </div>
        </div>

        <div className="bg-gray-100 p-3 rounded-lg">
          <h3 className="text-xs font-bold text-gray-500 mb-2">STOPS</h3>
          <div className="space-y-2 overflow-y-scroll">
            {colors.map((color, index) => (
              <div key={index} className="flex items-center gap-2">
                <div
                  className="w-6 h-6 rounded-md cursor-pointer hover:scale-110 transition-transform"
                  style={{ backgroundColor: color }}
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentColorIndex(index);
                  }}
                />
                <input
                  type="text"
                  value={color}
                  onChange={(e) => updateColorStop(index, e.target.value)}
                  className="input input-bordered input-xs  w-24 lg:w-28"
                />
                <input
                  type="number"
                  min="0"
                  max="100"
                  value={positions[index]}
                  onChange={(e) => updatePosition(index, parseInt(e.target.value, 10))}
                  className="input input-bordered input-xs w-16 text-center"
                />
                {colors.length > 2 && (
                  <button
                    className="btn btn-circle btn-xs btn-error"
                    onClick={(e) => {
                      e.preventDefault();
                      removeColorStop(index)
                    }}
                    aria-label="Remove color stop"
                  >
                    ×
                  </button>
                )}
              </div>
            ))}
          </div>
          {colors.length < 5 && (
            <button
              className="btn btn-sm btn-outline mt-2"
              onClick={(e) => {
                e.preventDefault()
                addColorStop()
              }}
            >
              Ajouter un Stop
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
